export default "/assets/images/current-room-status-thumbnail.jpg?f14b16b21ee5b7f9f4f07614d86b5435";